<template>
  <div class="breadcrumb" data-qa="breadcrumb-div-8x8od6">
    <div v-for="(item, index) in breadcrumbList" :key="index" :data-qa="`breadcrumb-div-avlzf-${index}`">
      <div class="hidden-sm-and-down" :data-qa="`breadcrumb-div-62nl08-${index}`">
        <v-icon v-if="item.icon" @click="routeToHome" medium class="mb-1" :data-qa="`breadcrumb-icon-wfytr-${index}`">{{ item.icon }}</v-icon>
        <span v-if="item.icon" class="px-2" :data-qa="`breadcrumb-span-ls9gx-${index}`">/</span>
        <span v-if="item.title" class="font-weight-black" :data-qa="`breadcrumb-span-zwdx5-${index}`">
          <a :data-qa="`breadcrumb-a-bal8c-${index}`">{{ getTitle(item.title) }}</a>
          <!-- TODO <a data-qa="breadcrumb-a-kurtm">{{ item.title }}</a> -->
        </span>
        <span v-if="item.title && item.subTitle" class="px-2" :data-qa="`breadcrumb-span-0bez7t-${index}`">/</span>
        <span v-if="item.subTitle" :data-qa="`breadcrumb-span-8becaf-${index}`">{{ getTitle(item.subTitle) }}</span>
        <span v-if="item.subTitle && item.breadcrumb" class="px-2" :data-qa="`breadcrumb-span-r0s8km-${index}`">/</span>
        <span @click="routeTo(index)" :data-qa="`breadcrumb-span-ombjzq-${index}`">{{ item.breadcrumb }}</span>
      </div>
      <div class="hidden-md-and-up" :data-qa="`breadcrumb-div-cq878c-${index}`">
        <v-icon v-if="item.icon" @click="routeToHome" medium class="mb-1" :data-qa="`breadcrumb-icon-2nh7mc-${index}`">{{ item.icon }}</v-icon>
        <span v-if="item.title && item.icon" class="px-1" :data-qa="`breadcrumb-span-1r83bk-${index}`">/</span>
        <span v-if="item.subTitle" class="px-1" :color="primaryColor" :data-qa="`breadcrumb-span-v1bpz7-${index}`">{{ item.subTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import appSettings from '@/plugins/appSettings'

export default {
  name: 'Breadcrumb',
  data: () => ({
    breadcrumbList: [],
    link: '',
    enableUkMarketSavingAccInDashboard:
        appSettings.defaultConfigurations.landingPageConfig
          .enableUkMarketSavingAccInDashboard,
    nominatedAccountsConfig: appSettings.defaultConfigurations.nominatedAccounts
  }),
  mounted () {
    this.updateList()
  },
  watch: {
    $route () {
      this.updateList()
    }
  },
  methods: {
    routeToHome () {
      this.$router.push('/home')
    },
    routeTo (pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link) {
        this.$router.push(this.breadcrumbList[pRouteTo].link)
      }
    },
    updateList () {
      this.breadcrumbList = []
      // eslint-disable-next-line no-prototype-builtins
      if (this.$route.meta.hasOwnProperty('breadcrumb')) {
        this.$route.meta.breadcrumb.link = this.$route.path
        if (this.enableUkMarketSavingAccInDashboard && this.$route.meta.breadcrumb.link === '/savings') {
          this.breadcrumbList.push({
            breadcrumb: '',
            icon: 'mdi-home',
            title: 'Accounts',
            subTitle: 'RegularSavings'
          })
        } else if (!this.enableUkMarketSavingAccInDashboard && this.$route.meta.breadcrumb.link === '/savings') {
          this.breadcrumbList.push({
            breadcrumb: '',
            icon: 'mdi-home',
            title: 'Accounts',
            subTitle: 'Savings'
          })
        } if (this.$route.meta.breadcrumb.link === '/payee' && this.nominatedAccountsConfig?.enableNominatedAccountFeatures) {
            this.breadcrumbList.push({
              breadcrumb: '',
              icon: 'mdi-home',
              title: 'Payments',
              subTitle: 'PayeeForNominated'
            })
        } else {
          this.breadcrumbList.push(this.$route.meta.breadcrumb)
        }
      }
    },
    getTitle (title) {
      const temp = title.replaceAll(' ', '')
      return this.$t(`breadcrumb.${temp}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumb {

  width: 100%;
  padding:0 1%;
  & a {
    text-decoration: none;
    color: #414141;
  }
}
</style>
